import React from 'react';

const ClipboardIcon = ({
    width = 40,
    height = 40,
    fill = 'none',
    stroke = 'black',
    className = '',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 40 40"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M15 8.33333H11.6667C10.7826 8.33333 9.93477 8.68452 9.30965 9.30964C8.68453 9.93477 8.33334 10.7826 8.33334 11.6667V31.6667C8.33334 32.5507 8.68453 33.3986 9.30965 34.0237C9.93477 34.6488 10.7826 35 11.6667 35H28.3333C29.2174 35 30.0652 34.6488 30.6904 34.0237C31.3155 33.3986 31.6667 32.5507 31.6667 31.6667V11.6667C31.6667 10.7826 31.3155 9.93477 30.6904 9.30964C30.0652 8.68452 29.2174 8.33333 28.3333 8.33333H25M15 8.33333C15 9.21739 15.3512 10.0652 15.9763 10.6904C16.6014 11.3155 17.4493 11.6667 18.3333 11.6667H21.6667C22.5507 11.6667 23.3986 11.3155 24.0237 10.6904C24.6488 10.0652 25 9.21739 25 8.33333M15 8.33333C15 7.44928 15.3512 6.60143 15.9763 5.97631C16.6014 5.35119 17.4493 5 18.3333 5H21.6667C22.5507 5 23.3986 5.35119 24.0237 5.97631C24.6488 6.60143 25 7.44928 25 8.33333M20 20H25M20 26.6667H25M15 20H15.0167M15 26.6667H15.0167"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ClipboardIcon;
